import { render } from "./ProductListMenu.vue?vue&type=template&id=05904913"
import script from "./ProductListMenu.vue?vue&type=script&lang=js"
export * from "./ProductListMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__